declare global {
    interface Window {
        dataLayer?: Array<Record<string, any>>;
    }
}

const VIEW_RATIO = 0.5;
const VIEW_DWELL_MS = 1000;

/**
 * Pushes an `article_event` (existing GTM trigger; the GA4 event name comes from eventCategory).
 * All four keys are always sent — GTM merges the dataLayer, so an omitted key would keep the
 * previous event's value.
 */
export function pushArticleEvent(eventCategory: string, eventAction: string, eventLabel = ''): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'article_event',
        eventCategory,
        eventAction,
        eventLabel,
    });
}

/**
 * Calls `onView` once, when at least half of the element has been visible for 1s without a break.
 */
export function onElementViewed(element: Element, onView: () => void): void {
    let dwellTimer: number | undefined;

    const observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) {
            window.clearTimeout(dwellTimer);
            dwellTimer = undefined;

            return;
        }

        if (dwellTimer === undefined) {
            dwellTimer = window.setTimeout(() => {
                observer.disconnect();
                onView();
            }, VIEW_DWELL_MS);
        }
    }, { threshold: VIEW_RATIO });

    observer.observe(element);
}
